import React from 'react';
import { useI18n } from '../i18n/i18n';
import AnalyticsContainer from './AnalyticsContainer';
import SystemInfoContainer from './SystemInfoContainer';
import SchneiderWidget from './SchneiderWidget';
import AlertsWidget from './AlertsWidget'; // 1. Importamos el nuevo widget

const Dashboard: React.FC = () => {
  const { t } = useI18n();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center">
        <h2 className="text-3xl font-bold text-gray-900">{t('dashboard.title')}</h2>
        <p className="mt-2 text-gray-600">{t('dashboard.subtitle')}</p>
      </div>

      {/* Main Layout */}
      <div className="w-full">
        <div className="space-y-6">
          
          {/* NUEVO: Secci�n de Alertas Cr�ticas */}
          {/* Lo ponemos al principio para que sea imposible ignorar una alarma activa */}
          <AlertsWidget />

          {/* 1. Analytics Container */}
          <AnalyticsContainer />

          {/* 2. Site Status (Antes SchneiderWidget) */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-1">
            <div className="px-4 py-3 border-b border-gray-100">
               <h3 className="text-lg font-bold text-gray-800">Site Status</h3>
            </div>
            <SchneiderWidget />
          </div>

          {/* 3. System Information Container (Al final) */}
          <SystemInfoContainer />
        </div>
      </div>

      {/* Footer */}
      <div className="text-center text-sm text-gray-500 mt-8">
        <p>Data Evolution v1.0.0</p>
        <p className="mt-1">
          Infrastructure monitoring and analytics platform
        </p>
      </div>
    </div>
  );
};

export default Dashboard;